import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import { useDialog } from '@ts-core/components/Dialog';
import { useGroups } from 'modules/groups/hooks';

export default function useGroupsPanel({
  courseId,
  showSelectedMark = false,
  onSelectGroup,
  selectedGroupId,
}) {
  const intl = useIntl();
  const { onCloseDialog, onOpenDialog, dialogProps } = useDialog();

  const [groupToEdit, setGroupToEdit] = useState();

  const {
    groups,
    loading,
    onCreateGroup,
    creatingGroup,
    onUpdateGroup,
    updatingGroup,
    onDeleteGroup,
  } = useGroups({
    courseId,
    onGroupCreated: onCloseDialog,
    onGroupUpdated: onCloseDialog,
  });

  /**
   * Add
   */
  const onOpenAddGroupDialog = useCallback(() => {
    setGroupToEdit();
    onOpenDialog({
      title: intl.formatMessage({ id: 'dialog.addGroup.title' }),
    });
  }, [intl, onOpenDialog]);

  /**
   * Update
   */
  const onOpenEditGroupDialog = useCallback(
    (group) => {
      setGroupToEdit(group);
      onOpenDialog({
        title: intl.formatMessage({ id: 'dialog.editGroup.title' }),
        dialogData: {
          groupInput: {
            name: group.name,
          },
        },
      });
    },
    [intl, onOpenDialog]
  );
  const handleEditGroup = useCallback(
    (formData) => {
      onUpdateGroup(groupToEdit._id, formData);
    },
    [groupToEdit, onUpdateGroup]
  );

  return {
    groups,
    loading,
    showSelectedMark,
    addingGroup: creatingGroup,
    editingGroup: updatingGroup,

    onSubmitGroupForm: !!groupToEdit ? handleEditGroup : onCreateGroup,
    onRemoveGroup: onDeleteGroup,

    onOpenAddGroupDialog,
    onOpenEditGroupDialog,
    onSelectGroup,
    dialogProps,
    selectedGroupId,
  };
}
